import { css } from "@emotion/react";
import { css as className } from "@emotion/css";
import { Colors, Fonts, Label, Spacing } from "@snapchat/snap-design-system";
import styled from "@emotion/styled";
import type { LabelProps } from "@snapchat/snap-design-system/lib/components/Label";

interface NavigationLabelProps extends LabelProps {
    width?: string;
}

export const metricsContainer = css`
    text-align: right;
    width: 180px;
`;

export const NavigationLabel = styled(Label)<NavigationLabelProps>`
    ${Fonts.Control.Label};
    width: ${({ width }) => width};
`;

export const parentFlexContainer = css`
    overflow-x: scroll;
    overflow-y: hidden;

    ::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;
`;

// We need to use !imporatant for this since SDS provides its own background that we need to overwrite
export const settingsButton = className`
    margin: ${Spacing["3XS"]}px;
    box-shadow: unset !important;
    :hover {
        background: rgba(0, 0, 0, 0.05) !important;
    }
`;

export const settingsContainer = css`
    padding-right: ${Spacing.XL}px;
`;

export const listItemClassName = className`
    font-weight: 400;
    font-size: ${Spacing.MD};
    :hover {
        background: rgba(0,0,0,.05);
        text-decoration: none;
        border: none;
        padding: 0 6px;
        color: inherit !important;
    }
`;

export const spanStyle = css`
    color: ${Colors.Gray.V300};
`;
